import { OnsiteCheck } from '@assets/icons/OnsiteCheck';
import { VirtualCheck } from '@assets/icons/VirtualCheck';
import { EventLocation, IEventCreation } from '@event/types/event';
import { Button as MUIButton, Typography } from '@mui/material';
import { useFormikContext } from 'formik';

const FirstStep = () => {
    const { touched, errors, setFieldValue, values } = useFormikContext<IEventCreation>();

    return (
        <>
            <div
                className="flex justify-center gap-10 relative"
                style={{
                    border: touched.type && errors.type ? '1px solid red' : '',
                }}
            >
                <div>
                    <MUIButton
                        color="white"
                        variant="text"
                        onClick={() => setFieldValue('type', EventLocation.VIRTUAL)}
                    >
                        <VirtualCheck selected={values.type === EventLocation.VIRTUAL && !!values.type} />
                    </MUIButton>
                    <Typography className="mt-10 w-fit mx-auto" variant="h5" fontWeight={600}>
                        Virtual event
                    </Typography>
                </div>
                <div>
                    <MUIButton
                        color="white"
                        variant="text"
                        onClick={() => setFieldValue('type', EventLocation.ONSITE)}
                        disableRipple
                    >
                        <OnsiteCheck selected={values.type === EventLocation.ONSITE && !!values.type} />
                    </MUIButton>
                    <Typography className="mt-10 w-fit mx-auto" variant="h5" fontWeight={600}>
                        Onsite event
                    </Typography>
                </div>
                <p className="absolute -bottom-5 text-[#f44336] font-roboto text-xs">
                    {touched.type && errors.type ? 'Required' : ''}
                </p>
            </div>
        </>
    );
};

export { FirstStep };
